export default __webpack_public_path__ + "static/media/pink-alert-trash-triangle.cc20c57d.svg";